module.exports = __webpack_public_path__ + "img/learning.6809a303.png";